import * as MyFPOApi from "../apis/MyFPO";
import * as MyBusinessApi from "../apis/MyBusiness";
import { useServiceConfig } from "./useServiceConfig";

const API_MODULES = {
  MyFPO: MyFPOApi,
  MyBusiness: MyBusinessApi,
};

// Returns the whole API module (apis/MyFPO or apis/MyBusiness) matching the current
// ServiceProvider's apiModule, so components call e.g. `const { getVendors } = useServiceApi();`
// instead of importing a specific service's API file directly.
export const useServiceApi = () => {
  const { apiModule } = useServiceConfig();
  const api = API_MODULES[apiModule];
  if (!api) {
    throw new Error(`useServiceApi: no API module registered for "${apiModule}"`);
  }
  return api;
};
